
import './App.css';
import ApiCall from './components/ApiCall';

function App() {
  return (
    <div className="App">
      <h1>Poke Info!</h1>
      <ApiCall/>
    </div>
  );
}

export default App;
